var _defs, _rect, _polyline, _line, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew305({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 2.1,
    width: 14,
    height: 11.8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "11.82 7.27 11.82 12.66 4.18 7.27 4.18 12.66"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.51,
    y1: 4.84,
    x2: 11.08,
    y2: 4.84
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8.12 6.43 7.95 5.96 11.03 4.84 7.95 3.72 8.12 3.25 12.49 4.84 8.12 6.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew305);
export default __webpack_public_path__ + "static/media/Symbolpack_New_305.b686d525a56f6085e9cd192c232bca46.svg";
export { ForwardRef as ReactComponent };